module.exports = __webpack_public_path__ + "media/country_flags/gb-eng-9f402aec.png";